import { render, staticRenderFns } from "./ConfiguracoesSistema.vue?vue&type=template&id=c5fedfba&scoped=true"
import script from "./ConfiguracoesSistema.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesSistema.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracoesSistema.vue?vue&type=style&index=0&id=c5fedfba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fedfba",
  null
  
)

export default component.exports